import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import EmployeeReferralRewardMatrix from "./index";

const employeeReferralRewardMatrixRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Employee Referral Reward Matrix",
		basePath: "employee-referral-reward-matrix",
		mainComponent: <EmployeeReferralRewardMatrix />,
	    layout: "/console",	   
	    subTitle:"Employee Referral Reward Matrix",
		level:5,
		moduleId: 0,
	})
]

export default employeeReferralRewardMatrixRoutes;